"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getIntegerFromUnknown_1 = __importDefault(require("./getIntegerFromUnknown"));
const sortDynamicCases = (cases) => Object.entries(cases)
    .sort(([a], [b]) => {
    const aA = a.replace(/[^a-zA-Z]/g, '');
    const bA = b.replace(/[^a-zA-Z]/g, '');
    if (aA === bA) {
        const aN = (0, getIntegerFromUnknown_1.default)(a.replace(/[^0-9]/g, '') || 0);
        const bN = (0, getIntegerFromUnknown_1.default)(b.replace(/[^0-9]/g, '') || 0);
        if (aN === bN) {
            return 0;
        }
        return aN > bN ? 1 : -1;
    }
    return aA > bA ? 1 : -1;
});
exports.default = sortDynamicCases;
